<template>
  <div>
    <slot></slot>
  </div>
</template>

<script>
 import SearchResultListItem from '@/components/SearchResultListItem.vue'

 export default {
   components: {
     SearchResultListItem
   },
   props: {
     items: {
       type: Array,
       default: () => []
     }
   }
 }
</script>
